var _style, _g, _rect, _rect2, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyHomeHelperLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 762.89 161.94",
    style: {
      enableBackground: "new 0 0 762.89 161.94"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#153673;}\r\n\t.st1{fill:#FF5735;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.98,141.59c0.7-1.27,1.66-2.26,2.88-2.97c1.22-0.71,2.57-1.06,4.07-1.06c1.83,0,3.39,0.43,4.69,1.3 c1.3,0.87,2.25,2.09,2.84,3.66h-1.92c-0.47-1.11-1.18-1.97-2.14-2.6c-0.96-0.62-2.12-0.94-3.47-0.94c-1.2,0-2.28,0.28-3.24,0.84 s-1.71,1.37-2.26,2.42c-0.55,1.05-0.82,2.27-0.82,3.66s0.27,2.6,0.82,3.65s1.3,1.85,2.26,2.41s2.04,0.84,3.24,0.84 c1.36,0,2.52-0.31,3.47-0.92c0.96-0.62,1.67-1.47,2.14-2.56h1.92c-0.59,1.56-1.54,2.77-2.85,3.63c-1.31,0.86-2.87,1.29-4.68,1.29 c-1.5,0-2.85-0.35-4.07-1.06c-1.22-0.71-2.18-1.7-2.88-2.96c-0.7-1.26-1.05-2.7-1.05-4.3S122.28,142.86,122.98,141.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.89,150.21h-7.44l-1.43,3.88h-1.73l5.97-16.14h1.85l5.94,16.14h-1.73L161.89,150.21z M161.4,148.85 l-3.23-8.84l-3.23,8.84H161.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.07,154.1l-4.05-6.83h-3.02v6.83h-1.64v-16.35h4.91c1.82,0,3.21,0.44,4.15,1.31 c0.94,0.87,1.42,2.02,1.42,3.44c0,1.19-0.34,2.2-1.02,3.03c-0.68,0.83-1.68,1.38-3.01,1.63l4.21,6.95H188.07z M181.01,145.93h3.3 c1.28,0,2.24-0.31,2.89-0.94c0.65-0.62,0.97-1.46,0.97-2.5c0-1.08-0.31-1.91-0.94-2.49s-1.61-0.88-2.95-0.88h-3.28V145.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.44,139.08v6.11h6.2v1.36h-6.2v6.2h6.9v1.36h-8.54v-16.38h8.54v1.36H206.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.13,142.52c-0.47-1.08-1.18-1.92-2.14-2.54s-2.09-0.92-3.38-0.92c-1.22,0-2.31,0.28-3.28,0.84 s-1.73,1.36-2.29,2.4c-0.56,1.04-0.84,2.24-0.84,3.61c0,1.37,0.28,2.58,0.84,3.63s1.33,1.85,2.29,2.41s2.06,0.84,3.28,0.84 c1.14,0,2.16-0.25,3.08-0.74c0.91-0.49,1.65-1.19,2.2-2.11c0.55-0.91,0.87-1.98,0.95-3.19h-6.88v-1.33h8.61v1.19 c-0.08,1.44-0.47,2.73-1.17,3.9c-0.7,1.16-1.64,2.08-2.82,2.75c-1.18,0.67-2.5,1.01-3.97,1.01c-1.51,0-2.89-0.35-4.12-1.06 c-1.23-0.71-2.2-1.7-2.91-2.97c-0.71-1.27-1.06-2.71-1.06-4.32s0.35-3.04,1.06-4.32c0.71-1.27,1.68-2.26,2.91-2.97 c1.23-0.71,2.6-1.06,4.12-1.06c1.75,0,3.28,0.44,4.59,1.31c1.31,0.87,2.26,2.09,2.85,3.65H241.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.89,137.74v16.35h-1.64v-16.35H259.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288.27,137.74l-6.2,16.35h-1.87l-6.2-16.35h1.78l5.36,14.58l5.4-14.58H288.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.07,139.08v6.11h6.2v1.36h-6.2v6.2h6.9v1.36h-8.54v-16.38h8.54v1.36H304.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334.6,154.1l-4.05-6.83h-3.02v6.83h-1.64v-16.35h4.91c1.82,0,3.21,0.44,4.15,1.31 c0.94,0.87,1.42,2.02,1.42,3.44c0,1.19-0.34,2.2-1.02,3.03c-0.68,0.83-1.68,1.38-3.01,1.63l4.21,6.95H334.6z M327.53,145.93h3.3 c1.28,0,2.24-0.31,2.89-0.94c0.65-0.62,0.97-1.46,0.97-2.5c0-1.08-0.31-1.91-0.94-2.49s-1.61-0.88-2.95-0.88h-3.28V145.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.03,135.5l-0.28,4.52h-1.15l-0.28-4.52H352.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.58,153.7c-0.82-0.37-1.46-0.9-1.93-1.57c-0.47-0.67-0.72-1.42-0.75-2.25h1.73 c0.08,0.8,0.43,1.49,1.05,2.09c0.62,0.6,1.54,0.9,2.74,0.9c1.11,0,1.99-0.28,2.63-0.85c0.65-0.57,0.97-1.29,0.97-2.16 c0-0.7-0.18-1.27-0.54-1.7c-0.36-0.43-0.8-0.75-1.33-0.96c-0.53-0.21-1.26-0.44-2.2-0.69c-1.09-0.3-1.96-0.58-2.6-0.87 s-1.19-0.72-1.64-1.31s-0.68-1.4-0.68-2.41c0-0.84,0.22-1.59,0.66-2.26c0.44-0.66,1.05-1.18,1.85-1.56 c0.79-0.37,1.71-0.56,2.74-0.56c1.51,0,2.73,0.37,3.66,1.11s1.46,1.7,1.6,2.87h-1.78c-0.11-0.67-0.48-1.27-1.1-1.79 s-1.47-0.78-2.53-0.78c-0.98,0-1.8,0.26-2.46,0.78c-0.65,0.52-0.98,1.24-0.98,2.14c0,0.69,0.18,1.24,0.54,1.66 c0.36,0.42,0.81,0.74,1.35,0.96c0.54,0.22,1.27,0.45,2.19,0.7c1.06,0.3,1.92,0.59,2.57,0.88c0.66,0.29,1.21,0.73,1.66,1.32 s0.68,1.39,0.68,2.39c0,0.76-0.2,1.49-0.61,2.18c-0.41,0.69-1.01,1.24-1.8,1.66c-0.79,0.42-1.75,0.63-2.85,0.63 C370.34,154.26,369.4,154.07,368.58,153.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.29,152.76h5.87v1.33h-7.51v-16.35h1.64V152.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M432.83,137.74v16.35h-1.64v-16.35H432.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M456.98,154.1l-7.09-7.56v7.56h-1.64v-16.35h1.64v7.65l7.09-7.65h2.08l-7.65,8.17l7.72,8.19H456.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M474.87,139.08v6.11h6.2v1.36h-6.2v6.2h6.9v1.36h-8.54v-16.38h8.54v1.36H474.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M523.65,137.74v1.36h-7.21v6.11h6.08v1.36h-6.08v7.53h-1.64v-16.35H523.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M547.52,150.21h-7.44l-1.43,3.88h-1.73l5.97-16.14h1.85l5.94,16.14h-1.73L547.52,150.21z M547.03,148.85 l-3.23-8.84l-3.23,8.84H547.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M580.97,137.95v16.14h-1.64V141.2l-5.75,12.89h-1.19l-5.75-12.84v12.84h-1.64v-16.14h1.73l6.25,13.99 l6.25-13.99H580.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M598.03,137.74v16.35h-1.64v-16.35H598.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M615.08,152.76h5.87v1.33h-7.51v-16.35h1.64V152.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M645.8,137.74l-5.24,9.99v6.36h-1.64v-6.36l-5.29-9.99h1.85l4.26,8.49l4.23-8.49H645.8z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 670.74,
    y: 144.58,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1418.8676 290.1776)",
    className: "st1",
    width: 77.38,
    height: 1.02
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.16,
    y: 144.58,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 105.6965 290.1776)",
    className: "st0",
    width: 77.38,
    height: 1.02
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.73,31.94v77.07h-15.46V76.22H81.26v32.79H65.8V31.94h15.46v31.69h33.01V31.94H129.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M329.91,31.94v77.07h-15.46V58.89l-20.65,50.13h-11.7l-20.76-50.13v50.13h-15.46V31.94h17.56l24.51,57.31 l24.51-57.31H329.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360.61,44.42v19.32h25.95V76h-25.95v20.43h29.26v12.59h-44.72V31.83h44.72v12.59H360.61z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M462.81,31.83v77.18h-7.73V72.91h-41.85v36.11h-7.73V31.83h7.73v34.67h41.85V31.83H462.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M488.21,38.13v28.82h29.26v6.4h-29.26v29.26h32.57v6.4h-40.3V31.72h40.3v6.4H488.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M543.75,102.72h27.71v6.29h-35.44V31.83h7.73V102.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M625.34,70.04c-4.34,4.05-10.86,6.07-19.54,6.07h-15.57v32.9h-7.73V31.83h23.3c8.61,0,15.11,2.03,19.49,6.07 c4.38,4.05,6.57,9.42,6.57,16.12C631.86,60.65,629.69,65.99,625.34,70.04z M623.91,54.03c0-5.15-1.43-9.05-4.31-11.7 s-7.47-3.98-13.8-3.98h-15.57v31.14h15.57C617.87,69.49,623.91,64.33,623.91,54.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M652.51,38.13v28.82h29.26v6.4h-29.26v29.26h32.57v6.4h-40.3V31.72h40.3v6.4H652.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M741.39,109.02l-19.1-32.24h-14.24v32.24h-7.73V31.83h23.19c8.61,0,15.14,2.06,19.6,6.18 c4.45,4.12,6.68,9.53,6.68,16.23c0,5.59-1.6,10.36-4.8,14.3c-3.2,3.94-7.93,6.5-14.19,7.67l19.88,32.79H741.39z M708.05,70.48 h15.57c6.03,0,10.58-1.47,13.64-4.42c3.05-2.94,4.58-6.88,4.58-11.81c0-5.08-1.47-9-4.42-11.76c-2.95-2.76-7.58-4.14-13.91-4.14 h-15.46V70.48z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.63,67.54h34.99v7.02H25.86l22.76,9.37v5.31l-22.76,9.42h22.76v7.02H13.63v-7.97l26.02-11.13L13.63,75.46 V67.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.63,32.8l22.81,11.83h12.18v7.02H36.44L13.63,63.53v-7.92l15.99-7.52l-15.99-7.47V32.8z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.97,9.28l48.33,38.65l-52.19-33.26c-1.55-0.99-2-3.04-1.02-4.58c0.99-1.55,3.04-2,4.58-1.02 C188.78,9.13,188.88,9.21,188.97,9.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.64,14.67l-52.19,33.26l48.33-38.65c1.43-1.15,3.52-0.91,4.67,0.52s0.91,3.52-0.52,4.67 C188.84,14.54,188.74,14.61,188.64,14.67z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.84,109.14c1.46-10.84,5.09-19.88,13.07-26.75c4.09-3.53,8.34-6.87,12.04-10.78 c0.09,3.07-0.54,5.98-3.8,10.49c-2.48,3.43-5.18,6.7-8.12,10.47c13.2-3.47,20-21.12,18.47-47.79c7.82,13.65,8.69,26.71,2.61,39.87 C219.52,98.96,208.02,106.93,191.84,109.14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.7,92.68c-3.41-7.37-11.51-12.37-10.84-19.91c4.37,3.67,9.99,7.81,14.9,12.66 c6.3,6.22,8.77,14.39,10.14,23.69c-15.33-1.98-26.5-9.32-33.39-22.55c-7.1-13.64-6.4-27.3,1.37-40.64 C148.83,65.01,152.69,81.38,169.7,92.68z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.94,45.17c2.65,10.63,0.07,19.89-8.04,26.85c-9.5,8.16-16.95,17.34-19.31,30.04 c-1.48-12.61-0.81-24.63,9.02-34.17c2.7-2.62,5.7-4.94,8.63-7.31C209.24,56.55,213.2,51.91,213.94,45.17z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.85,43.62c0.76,8.7,5.21,13.51,10.63,17.81c3.46,2.74,6.57,5.92,9.9,8.84c5.79,5.08,3.98,11.01,2.03,16.61 c-5.54-5.6-11.42-11.18-16.88-17.15C161.12,62.71,159.34,54.34,161.85,43.62z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.72,36.21c-6.22-5.43-15.66-5.4-21.84,0.36c-0.29,0.26-0.58,0.56-0.84,0.84 c-6.51,7.04-6.51,17.89,0,24.91l0.03,0.03h5.88l-2.81-2.96c-4.99-5.37-4.99-13.66,0-19.02c4.52-4.9,12.14-5.22,17.04-0.7 c0.23,0.22,0.47,0.45,0.69,0.7l1.7,1.79l0.15,0.15l0.15,0.16v-6.14C187.81,36.29,187.77,36.25,187.72,36.21z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.38,37.4c-0.26-0.27-0.53-0.58-0.82-0.84c-6.18-5.75-15.62-5.78-21.84-0.36 c-0.05,0.04-0.1,0.08-0.15,0.12v6.14l0.15-0.16l0.15-0.15l1.7-1.79c0.22-0.25,0.45-0.48,0.69-0.7c4.9-4.52,12.52-4.21,17.04,0.7 c4.99,5.36,4.99,13.65,0,19.02l-2.81,2.96h5.86l0.03-0.03C216.9,55.3,216.9,44.45,210.38,37.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyHomeHelperLogo);
export default __webpack_public_path__ + "static/media/My-Home-Helper-Logo.0ccc2b124ec1ff1748645f53e3415a6d.svg";
export { ForwardRef as ReactComponent };